(function () {
 'use strict';
 var R = (window.theme && window.theme.routes) || {};
 var ROOT = R.root || '/';
 var URL_ADD = R.cart_add_url || (ROOT + 'cart/add.js');
 var URL_CHANGE = R.cart_change_url || (ROOT + 'cart/change.js');
 var URL_CARTJS = ROOT + 'cart.js';
 var URL_SECTION = ROOT + '?section_id=api-cart-items';
 var GIFT = { BOOKLET: 54704785686870, MASK: 54705310531926, VAN: 54705315938646 };
 var GIFT_IDS = [GIFT.BOOKLET, GIFT.MASK, GIFT.VAN];
 var GIFT_SKUS = ['GIFT-RECEPTI', 'GIFT-MASK', 'GIFT-VAN'];
 var REAL_MASK_SKUS = ['MASK'];
 var REAL_VAN_SKUS = ['VAN-M', 'VAN-V'];
 var GIFT_IMG = {
  recepti: 'https://cdn.shopify.com/s/files/1/0922/3222/1014/files/ChatGPTImageJun30_2026_09_00_05AM.png?v=1784636050',
  maska: 'https://cdn.shopify.com/s/files/1/0922/3222/1014/files/GIFT_CARD_d30d3073-26a4-46bc-b5e8-ac7445e22092.png?v=1784635779'
 };
 var UPSELL = [
  { pid: 9654597976406, vid: 53336020713814, name: 'Malina', price: '3.990 RSD', img: 'https://cdn.shopify.com/s/files/1/0922/3222/1014/files/3_ecda5d5d-6cec-4bf1-b34b-5c156154b317.png?v=1777460278' },
  { pid: 9654598336854, vid: 53336020943190, name: 'Jagoda i vanila', price: '3.990 RSD', img: 'https://cdn.shopify.com/s/files/1/0922/3222/1014/files/2_c3bd0722-a513-4b73-ad44-30fc881c819d.png?v=1777460279' },
  { pid: 10410595877206, vid: 53336019370326, name: 'Kolagen peptidi', price: '4.990 RSD', img: 'https://cdn.shopify.com/s/files/1/0922/3222/1014/files/Navodila_za_darilno_pakiranje_Ker_je_nase_gele_potrebno_hraniti_v_hladilniku_vam_darilno_pakiranje_prilagamo_loceno_prazno._Gele_hranite_v_hladilniku_vse_do_trenutka_ko_boste_darilo_p.png?v=1777460274' }
 ];
 var SHIP_EMOJI = '🚚';
 var ICON_COD = '<svg class="kai-tri" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="2.5" y="6.5" width="19" height="11" rx="2"/><circle cx="12" cy="12" r="2.5"/></svg>';
 var ICON_CLOCK = '<svg class="kai-tri" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
 var ICON_DROP = '<svg class="kai-tri" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 3.5c3.5 4 5.5 6.5 5.5 9.5a5.5 5.5 0 0 1-11 0c0-3 2-5.5 5.5-9.5z"/></svg>';
 var ICON_HEART = '<svg class="kai-tri" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 20s-6.6-4.2-6.6-9.1A3.4 3.4 0 0 1 12 8.3a3.4 3.4 0 0 1 6.6 2.6c0 4.9-6.6 9.1-6.6 9.1z"/></svg>';
 var TRUST_HTML =
  '<div class="kai-trust">' +
   '<div class="kai-tr">' + ICON_COD + '<span class="kai-trl">Plaćanje<br>pouzećem</span></div>' +
   '<div class="kai-tr">' + ICON_CLOCK + '<span class="kai-trl">Slanje<br>1–2 dana</span></div>' +
   '<div class="kai-tr">' + ICON_DROP + '<span class="kai-trl">90+<br>minerala</span></div>' +
   '<div class="kai-tr">' + ICON_HEART + '<span class="kai-trl">Ručno<br>rađeno</span></div>' +
  '</div>';
 var FREE_SHIP_THRESHOLD = 1190000;
 var CURRENCY = 'RSD';
 var busy = false;
 var timer = null;
 var runPromise = null;
 var settled = false;
 var CHECKOUT_WAIT_MS = 6000;

 function fmtMoney(cents) {
  var v = Math.round((cents || 0) / 100);
  try {
   return new Intl.NumberFormat('sr-RS', { maximumFractionDigits: 0 }).format(v) + ' ' + CURRENCY;
  } catch (e) {
   return v + ' ' + CURRENCY;
  }
 }
 function isGiftItem(it) {
  if (!it) return false;
  if (GIFT_IDS.indexOf(it.id) !== -1) return true;
  if (it.sku && GIFT_SKUS.indexOf(it.sku) !== -1) return true;
  if (it.properties && it.properties._kai_gift) return true;
  return false;
 }
 function skuIn(list, sku) { return sku && list.indexOf(sku) !== -1; }
 function analyze(cart) {
  CURRENCY = (cart.currency || CURRENCY);
  var paidCount = 0, paidSubtotal = 0;
  var hasRealMask = false, hasRealVan = false;
  var present = {};
  (cart.items || []).forEach(function (it) {
   if (isGiftItem(it)) {
    present[it.id] = { key: it.key, qty: it.quantity };
    return;
   }
   paidCount += it.quantity;
   paidSubtotal += it.final_line_price;
   if (skuIn(REAL_MASK_SKUS, it.sku)) hasRealMask = true;
   if (skuIn(REAL_VAN_SKUS, it.sku)) hasRealVan = true;
  });
  return {
   paidCount: paidCount,
   paidSubtotal: paidSubtotal,
   hasRealMask: hasRealMask,
   hasRealVan: hasRealVan,
   present: present
  };
 }
 /* RS ponudba (25. 9. 2026): pri 2+ izdelkih je maska VEDNO gratis, tudi ce kupec ze kupi masko. */
 function desiredGifts(a) {
  var want = {};
  if (a.paidCount >= 1) want[GIFT.BOOKLET] = 1;
  if (a.paidCount >= 2) want[GIFT.MASK] = 1;
  return want;
 }
 function getCart() {
  return fetch(URL_CARTJS, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
 }
 function addGift(id, attempt) {
  attempt = attempt || 1;
  return fetch(URL_ADD, {
   method: 'POST',
   headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
   body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _kai_gift: 'true' } }] })
  }).then(function (r) {
   if (r.ok) return r;
   if (attempt < 3) {
    return new Promise(function (res) { setTimeout(res, 200 * attempt); })
     .then(function () { return addGift(id, attempt + 1); });
   }
   console.warn('KAI gifts: ne mogu dodati poklon', id);
   return r;
  }).catch(function (err) {
   if (attempt < 3) {
    return new Promise(function (res) { setTimeout(res, 200 * attempt); })
     .then(function () { return addGift(id, attempt + 1); });
   }
   console.warn('KAI gifts: greška pri dodavanju poklona', id, err);
  });
 }
 function changeQty(key, qty) {
  return fetch(URL_CHANGE, {
   method: 'POST',
   headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
   body: JSON.stringify({ id: key, quantity: qty })
  });
 }
 function reconcile(cart) {
  var a = analyze(cart);
  var want = desiredGifts(a);
  var adds = [];
  var others = [];
  GIFT_IDS.forEach(function (id) {
   var have = a.present[id];
   var wantQty = want[id] ? 1 : 0;
   var haveQty = have ? have.qty : 0;
   if (wantQty === 1 && haveQty === 0) {
    adds.push(id);
   } else if (wantQty === 0 && haveQty > 0) {
    others.push({ type: 'remove', key: have.key });
   } else if (wantQty === 1 && haveQty > 1) {
    others.push({ type: 'set', key: have.key, qty: 1 });
   }
  });
  if (!adds.length && !others.length) return Promise.resolve(false);
  var jobs = adds.map(function (id) { return addGift(id); });
  var seq = others.reduce(function (p, op) {
   return p.then(function () {
    if (op.type === 'remove') return changeQty(op.key, 0);
    return changeQty(op.key, 1);
   });
  }, Promise.resolve());
  jobs.push(seq);
  return Promise.all(jobs).then(function () { return true; });
 }
 function drawer() { return document.getElementById('cart-drawer'); }
 function decorateGiftLines(cart) {
  var d = drawer();
  if (!d) return;
  var a = analyze(cart);
  var giftKeys = {};
  Object.keys(a.present).forEach(function (id) { giftKeys[a.present[id].key] = true; });
  d.querySelectorAll('[data-cart-item]').forEach(function (el) {
   var key = el.getAttribute('data-item');
   if (giftKeys[key]) {
    el.classList.add('kai-gift-line');
    if (!el.querySelector('.kai-gift-badge')) {
     var info = el.querySelector('.cart__item__info') || el;
     var badge = document.createElement('span');
     badge.className = 'kai-gift-badge';
     badge.textContent = 'Poklon';
     info.insertBefore(badge, info.firstChild);
    }
   } else {
    el.classList.remove('kai-gift-line');
   }
  });
 }
 function pluralProizvod(n) { return n === 1 ? 'proizvod' : 'proizvoda'; }
 function renderProgress(cart) {
  var d = drawer();
  if (!d) return;
  var body = d.querySelector('[data-cart-drawer-body]');
  if (!body) return;
  var a = analyze(cart);
  if (a.paidCount < 1) {
   var ex = body.querySelector('.kai-gift-progress');
   if (ex) ex.parentNode.removeChild(ex);
   return;
  }
  var doneRecepti = a.paidCount >= 1;
  var doneMaska = a.paidCount >= 2;
  var doneDostava = a.paidSubtotal >= FREE_SHIP_THRESHOLD;
  var steps = (doneRecepti ? 1 : 0) + (doneMaska ? 1 : 0) + (doneDostava ? 1 : 0);
  var pct = Math.round((steps / 3) * 100);
  var msg;
  if (a.paidCount < 2) {
   var need = 2 - a.paidCount;
   msg = 'Još <em>' + need + ' ' + pluralProizvod(need) + '</em> do besplatne maske za lice.';
  } else if (!doneDostava) {
   var rem = FREE_SHIP_THRESHOLD - a.paidSubtotal;
   msg = 'Još <em>' + fmtMoney(rem) + '</em> do besplatne dostave.';
  } else {
   msg = '<em>Otključali ste sve poklone.</em> Dostava je besplatna.';
  }
  var html =
   '<div class="kai-gift-progress" data-kai-progress>' +
    '<p class="kai-gp-msg">' + msg + '</p>' +
    '<div class="kai-gp-track"><div class="kai-gp-fill" style="width:' + pct + '%"></div>' +
     '<span class="kai-gp-dot ' + (doneRecepti ? 'on' : '') + '" style="left:0"></span>' +
     '<span class="kai-gp-dot ' + (doneMaska ? 'on' : '') + '" style="left:50%"></span>' +
     '<span class="kai-gp-dot ' + (doneDostava ? 'on' : '') + '" style="left:100%"></span>' +
    '</div>' +
    '<div class="kai-gp-tiles">' +
     '<div class="kai-gp-tile ' + (doneRecepti ? 'on' : '') + '"><div class="kai-gp-thumb"><img src="' + GIFT_IMG.recepti + '" alt=""></div><span class="kai-gp-tname">Recepti</span><span class="kai-gp-tstate">' + (doneRecepti ? 'Gratis' : '') + '</span></div>' +
     '<div class="kai-gp-tile ' + (doneMaska ? 'on' : '') + '"><div class="kai-gp-thumb"><img src="' + GIFT_IMG.maska + '" alt=""></div><span class="kai-gp-tname">Maska</span><span class="kai-gp-tstate">' + (doneMaska ? 'Gratis' : '') + '</span></div>' +
     '<div class="kai-gp-tile ' + (doneDostava ? 'on' : '') + '"><div class="kai-gp-thumb kai-gp-ship">' + SHIP_EMOJI + '</div><span class="kai-gp-tname">Besplatna dostava</span><span class="kai-gp-tstate">' + (doneDostava ? 'Gratis' : '') + '</span></div>' +
    '</div>' +
   '</div>';
  var existing = body.querySelector('.kai-gift-progress');
  if (existing) {
   existing.outerHTML = html;
  } else {
   body.insertAdjacentHTML('afterbegin', html);
  }
 }
 function tgl(el, hide) { if (el) el.classList[hide ? 'add' : 'remove']('hidden'); }
 function syncEmpty(d, cart) {
  var empty = cart.item_count === 0;
  tgl(d.querySelector('[data-items-holder]'), empty);
  tgl(d.querySelector('[data-cart-items-qty]'), empty);
  tgl(d.querySelector('[data-cart-form]'), empty);
  tgl(d.querySelector('[data-cart-notes-holder]'), empty);
  d.querySelectorAll('.cart-drawer__empty-message').forEach(function (e) { tgl(e, !empty); });
  var qtyEl = d.querySelector('[data-cart-items-qty]');
  var S = (window.theme && window.theme.strings) || {};
  if (qtyEl && !empty) {
   var tpl = (cart.item_count === 1 ? S.cart_items_one : S.cart_items_many) || '';
   qtyEl.textContent = tpl.replace('{{ count }}', cart.item_count).replace('{{count}}', cart.item_count);
  }
 }
 function refreshDrawerDOM() {
  return Promise.all([
   fetch(URL_SECTION).then(function (r) { return r.text(); }),
   getCart()
  ]).then(function (res) {
   var txt = res[0], cart = res[1];
   var d = drawer();
   if (!d) return cart;
   var doc = new DOMParser().parseFromString(txt, 'text/html');
   var apiLines = doc.querySelector('[data-api-line-items]');
   var apiPrice = doc.querySelector('[data-api-cart-price]');
   var holder = d.querySelector('[data-items-holder]');
   var priceHolder = d.querySelector('[data-cart-price-holder]');
   if (holder) holder.innerHTML = apiLines ? apiLines.innerHTML : '';
   if (priceHolder && apiPrice) priceHolder.innerHTML = apiPrice.innerHTML;
   syncEmpty(d, cart);
   return cart;
  }).catch(function () { return null; });
 }
 function renderTrust(cart) {
  var d = drawer();
  if (!d) return;
  var body = d.querySelector('[data-cart-drawer-body]');
  if (!body) return;
  var a = analyze(cart);
  var existing = body.querySelector('.kai-trust');
  if (a.paidCount < 1) {
   if (existing) existing.parentNode.removeChild(existing);
   return;
  }
  if (!existing) body.insertAdjacentHTML('beforeend', TRUST_HTML);
 }
 function renderUpsell(cart) {
  var d = drawer();
  if (!d) return;
  var body = d.querySelector('[data-cart-drawer-body]');
  if (!body) return;
  var a = analyze(cart);
  var existing = body.querySelector('.kai-upsell');
  if (a.paidCount < 1) {
   if (existing) existing.parentNode.removeChild(existing);
   return;
  }
  var inCart = {};
  (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
  var picks = UPSELL.filter(function (p) { return !inCart[p.pid]; }).slice(0, 3);
  if (!picks.length) {
   if (existing) existing.parentNode.removeChild(existing);
   return;
  }
  var sig = picks.map(function (p) { return p.vid; }).join(',');
  if (existing && existing.getAttribute('data-sig') === sig) return;
  var items = picks.map(function (p) {
   return '<button type="button" class="kai-up-item" data-kai-add="' + p.vid + '">' +
    '<span class="kai-up-thumb"><img src="' + p.img + '" alt=""></span>' +
    '<span class="kai-up-nm">' + p.name + '</span>' +
    '<span class="kai-up-pr">' + p.price + '</span>' +
    '<span class="kai-up-plus">+</span>' +
   '</button>';
  }).join('');
  var html = '<div class="kai-upsell" data-sig="' + sig + '"><p class="kai-up-h">Možda vam se svidi</p><div class="kai-up-row">' + items + '</div></div>';
  if (existing) {
   existing.outerHTML = html;
  } else {
   var trust = body.querySelector('.kai-trust');
   if (trust) trust.insertAdjacentHTML('beforebegin', html);
   else body.insertAdjacentHTML('beforeend', html);
  }
 }
 function fixCheckout(d) {
  var btn = d.querySelector('.cart__checkout');
  if (!btn) return;
  for (var i = 0; i < btn.childNodes.length; i++) {
   var n = btn.childNodes[i];
   if (n.nodeType === 3 && n.textContent.trim().length) {
    if (n.textContent.indexOf('Nastavi') === -1) n.textContent = ' Nastavi na plaćanje ';
    return;
   }
  }
 }
 function render(cart) {
  if (!cart) return;
  decorateGiftLines(cart);
  renderProgress(cart);
  renderTrust(cart);
  renderUpsell(cart);
  var d = drawer();
  if (d) fixCheckout(d);
 }
 function onCartClick(e) {
  var t = e.target;
  if (!t || !t.closest || !t.closest('#cart-drawer')) return;
  var addBtn = t.closest('[data-kai-add]');
  if (addBtn) {
   e.preventDefault();
   e.stopImmediatePropagation();
   var vid = parseInt(addBtn.getAttribute('data-kai-add'), 10);
   if (vid) fetch(URL_ADD, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
   }).then(function () { schedule(true); }).catch(function () {});
   return;
  }
  var plus = t.closest('[data-quantity-plus]');
  var minus = t.closest('[data-quantity-minus]');
  var rem = t.closest('[data-item-remove]');
  if (!plus && !minus && !rem) return;
  var line = t.closest('[data-cart-item]');
  if (!line) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (line.classList.contains('kai-gift-line')) return;
  var key = line.getAttribute('data-item');
  var field = line.querySelector('[data-quantity-field]');
  var shownQty = field ? (parseInt(field.value, 10) || 1) : 1;
  /* Kljuc vrstice se lahko spremeni (darila, popusti), zato ga vedno preverimo v pravi kosarici. */
  getCart().then(function (cart) {
   var items = cart.items || [];
   var item = null, i;
   for (i = 0; i < items.length; i++) { if (items[i].key === key) { item = items[i]; break; } }
   if (!item) {
    var vidKey = parseInt(String(key).split(':')[0], 10);
    for (i = 0; i < items.length; i++) {
     if (items[i].variant_id === vidKey && !isGiftItem(items[i])) { item = items[i]; break; }
    }
   }
   var useKey = item ? item.key : key;
   var qty = item ? item.quantity : shownQty;
   var newQty = rem ? 0 : (plus ? qty + 1 : qty - 1);
   if (newQty < 0) newQty = 0;
   if (field && newQty > 0) field.value = newQty;
   return changeQty(useKey, newQty);
  }).then(function () { schedule(true); }).catch(function () {});
 }

 function runNow() {
  if (busy && runPromise) return runPromise;
  busy = true;
  settled = false;
  runPromise = getCart()
   .then(function (cart) {
    return reconcile(cart).then(function (changed) {
     if (changed) return refreshDrawerDOM();
     return cart;
    });
   })
   .then(function (cart) { render(cart); return cart; })
   .catch(function (e) { console.warn('KAI gifts:', e); })
   .then(function (cart) { busy = false; settled = true; return cart; });
  return runPromise;
 }
 function run() { runNow(); }
 function schedule(fast) {
  settled = false;
  if (timer) clearTimeout(timer);
  timer = setTimeout(function () { timer = null; run(); }, fast ? 0 : 150);
 }

 function setCheckoutWaiting(on) {
  document.querySelectorAll('.cart__checkout').forEach(function (b) {
   if (on) {
    b.setAttribute('aria-busy', 'true');
    b.style.opacity = '.65';
    b.style.pointerEvents = 'none';
   } else {
    b.removeAttribute('aria-busy');
    b.style.opacity = '';
    b.style.pointerEvents = '';
   }
  });
 }

 function ensureGiftsThen(done) {
  if (timer) { clearTimeout(timer); timer = null; }
  setCheckoutWaiting(true);
  var finished = false;
  var guard = setTimeout(function () {
   if (finished) return;
   finished = true;
   setCheckoutWaiting(false);
   done();
  }, CHECKOUT_WAIT_MS);
  runNow().then(function () {
   return getCart().then(function (cart) {
    var a = analyze(cart);
    var want = desiredGifts(a);
    var missing = Object.keys(want).some(function (id) { return !a.present[id]; });
    if (missing) return runNow();
   });
  }).catch(function () {}).then(function () {
   if (finished) return;
   finished = true;
   clearTimeout(guard);
   setCheckoutWaiting(false);
   done();
  });
 }

 function isCheckoutTrigger(el) {
  if (!el || !el.closest) return null;
  return el.closest('button[name="checkout"], .cart__checkout, [data-kai-checkout]');
 }

 function onCheckoutClick(e) {
  var btn = isCheckoutTrigger(e.target);
  if (!btn) return;
  if (btn.dataset.kaiReady === '1') { delete btn.dataset.kaiReady; return; }
  /* Vedno preveri darila pred blagajno (podvojeno darilo se lahko doda med prehodom strani). */
  e.preventDefault();
  e.stopImmediatePropagation();
  ensureGiftsThen(function () {
   btn.dataset.kaiReady = '1';
   var form = btn.closest('form');
   if (form) {
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'checkout';
    hidden.value = '';
    form.appendChild(hidden);
    HTMLFormElement.prototype.submit.call(form);
   } else {
    btn.click();
   }
  });
 }

 var _fetch = window.fetch;
 window.fetch = function () {
  var url = arguments[0];
  var u = (typeof url === 'string') ? url : (url && url.url) || '';
  var p = _fetch.apply(this, arguments);
  if (/\/cart\/(add|change|update|clear)/.test(u)) {
   settled = false;
   p.then(function () { if (!busy) schedule(true); }).catch(function () {});
  }
  return p;
 };
 var _open = XMLHttpRequest.prototype.open;
 XMLHttpRequest.prototype.open = function (m, u) {
  this.addEventListener('load', function () {
   if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
    settled = false;
    if (!busy) schedule(true);
   }
  });
  return _open.apply(this, arguments);
 };
 function isOurNode(n) {
  return n && n.nodeType === 1 && n.classList &&
   (n.classList.contains('kai-gift-progress') || n.classList.contains('kai-gift-badge') || n.classList.contains('kai-trust') || n.classList.contains('kai-upsell'));
 }
 function isOurMutation(m) {
  if (m.target && m.target.nodeType === 1 && m.target.closest &&
    m.target.closest('.kai-gift-progress, .kai-trust, .kai-upsell')) return true;
  var nodes = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
  var els = nodes.filter(function (n) { return n.nodeType === 1; });
  if (!els.length) return true;
  return els.every(isOurNode);
 }
 var mo = new MutationObserver(function (muts) {
  for (var i = 0; i < muts.length; i++) {
   if (!isOurMutation(muts[i])) { schedule(); return; }
  }
 });
 function boot() {
  var d = drawer();
  if (d) mo.observe(d, { childList: true, subtree: true });
  mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', onCartClick, true);
  document.addEventListener('click', onCheckoutClick, true);
  schedule(true);
  /* Drugi prehod: dodajanje s prejsnje strani (npr. Appstle set) se lahko zakljuci sele po nalaganju. */
  setTimeout(function () { schedule(true); }, 2500);
  setTimeout(function () { schedule(true); }, 6000);
 }
 if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
 } else {
  boot();
 }
})();